import React from 'react';

export const SvgReplay5 = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.707 11.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 7l3.293 3.293a1 1 0 010 1.414z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.707 11.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 111.414 1.414L10.414 7l3.293 3.293a1 1 0 010 1.414z"
      fill="currentColor"
    />
    <path
      d="M6.311 21.947c-.636 0-1.203-.116-1.7-.346a2.908 2.908 0 01-1.172-.95A2.424 2.424 0 013 19.261h2.045c.015.322.144.58.388.777.247.193.54.29.878.29.398 0 .723-.129.976-.384.256-.259.382-.597.38-1.014.002-.42-.126-.76-.384-1.019-.256-.258-.584-.388-.985-.388a1.534 1.534 0 00-.72.166 1.215 1.215 0 00-.511.465l-1.862-.35.379-4.704h5.6v1.7H5.317l-.2 2.058h.051c.145-.24.378-.44.699-.596a2.47 2.47 0 011.104-.239c.522 0 .988.122 1.397.367.412.241.736.576.972 1.005.239.43.358.92.358 1.475 0 .6-.142 1.13-.426 1.594a2.936 2.936 0 01-1.185 1.09c-.506.262-1.098.393-1.777.393z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.771 6.02c-.305.008-.563.014-.771.014a1 1 0 100 2c.235 0 .52-.007.819-.014l.118-.003c.35-.009.726-.017 1.112-.017.785 0 1.544.034 2.122.149a6.006 6.006 0 013.073 1.638 5.978 5.978 0 011.3 6.519 5.987 5.987 0 01-2.21 2.685A6.013 6.013 0 0114 20a1 1 0 100 2 8.012 8.012 0 004.444-1.345 7.986 7.986 0 002.947-3.582 7.967 7.967 0 00-1.735-8.702 8.006 8.006 0 00-4.096-2.184C14.78 6.032 13.857 6 13.048 6c-.41 0-.808.009-1.16.017l-.117.003z"
      fill="currentColor"
    />
  </svg>
);
